export const state = () => ({
  data: [],
  pagination: {},
  selectedDocuments: [],
});

export const mutations = {
  SET_SHARED_DOCUMENTS(state, sharedDocuments) {
    if (sharedDocuments.page === 1) {
      state.data = sharedDocuments.data;
    } else {
      state.data.push(...sharedDocuments.data);
    }
    state.pagination = sharedDocuments.pagination;
  },
  ADD_SHARED_DOCUMENT(state, sharedDocument) {
    state.data.unshift(sharedDocument);
  },
  UPDATE_SHARED_DOCUMENT(state, updatedSharedDocument) {
    const index = state.data.findIndex(
      (doc) => doc.id === updatedSharedDocument.id
    );
    if (index !== -1) {
      state.data.splice(index, 1, updatedSharedDocument);
    }
  },
  DELETE_SHARED_DOCUMENT(state, sharedDocumentId) {
    state.data = state.data.filter((doc) => doc.id !== sharedDocumentId);
  },
  SET_DATA(state, data) {
    state.data = data;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination;
  },
  SET_SELECTED_DOCUMENTS(state, documents) {
    state.selectedDocuments = documents;
  },
  ADD_SELECTED_DOCUMENT(state, document) {
    state.selectedDocuments.push(document);
  },
  REMOVE_SELECTED_DOCUMENT(state, sharedDocumentId) {
    state.selectedDocuments = state.selectedDocuments.filter(
      (doc) => doc.id !== sharedDocumentId
    );
  },
};

export const actions = {
  async fetchSharedDocuments(
    { commit },
    {
      organization_id,
      profile_type = null,
      page = 1,
      per_page = 10,
      search = null,
    }
  ) {
    const response = await this.$backend.fetchSharedDocuments(organization_id, {
      profile_type,
      page,
      per_page,
      search,
    });

    commit("SET_SHARED_DOCUMENTS", {
      data: response.data,
      pagination: response.pagination,
      page,
    });
  },
  updateSelectedDocuments({ commit }, documents) {
    commit("SET_SELECTED_DOCUMENTS", documents);
  },
  addSelectedDocument({ commit }, document) {
    commit("ADD_SELECTED_DOCUMENT", document);
  },
  async createSharedDocument(
    { commit },
    { organization_id, sharedDocumentData, autoSelect = false }
  ) {
    const response = await this.$backend.createSharedDocument(
      organization_id,
      sharedDocumentData
    );
    commit("ADD_SHARED_DOCUMENT", response.data);
    if (autoSelect) {
      commit("ADD_SELECTED_DOCUMENT", response.data);
    }
    return response.data;
  },
  async updateSharedDocument(
    { commit },
    { organization_id, sharedDocumentId, sharedDocumentData }
  ) {
    const response = await this.$backend.updateSharedDocument(
      organization_id,
      sharedDocumentId,
      sharedDocumentData
    );
    commit("UPDATE_SHARED_DOCUMENT", response.data);
    if (autoSelect) {
      commit("ADD_SELECTED_DOCUMENT", response.data);
    }
    return response.data;
  },
  async deleteSharedDocument(
    { commit },
    { organization_id, sharedDocumentId }
  ) {
    await this.$backend.deleteSharedDocument(organization_id, sharedDocumentId);
    commit("DELETE_SHARED_DOCUMENT", sharedDocumentId);
    commit("REMOVE_SELECTED_DOCUMENT", sharedDocumentId);
  },
};
